import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    antecedentesAndrogenicos: [],
  },

  getters: {
    getAntecedentesAndrogenicos: (state) => state.antecedentesAndrogenicos,
  },

  mutations: {
    SET_ANTECEDENTES_ANDROGENICOS(state, antecedentesAndrogenicos) {
      state.antecedentesAndrogenicos = antecedentesAndrogenicos;
    },
  },

  actions: {
    async fetchAntecedentesAndrogenicos({ commit }, idHistoriaClinica) {
      await axios
        .get(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/antecedentesAndrogenicos`)
        .then((response) => {
          commit('SET_ANTECEDENTES_ANDROGENICOS', response.data.data);
        });
    },

    async saveAntecedentesAndrogenicos(context, antecedentesAndrogenicos) {
      const { idHistoriaClinica } = context.rootState.historiaClinica;
      await axios
        .post(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/antecedentesAndrogenicos`, antecedentesAndrogenicos);
    },

    async updateAntecedentesAndrogenicos(_, antecedentesAndrogenicos) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/historiaClinica/${
            antecedentesAndrogenicos.fk_idHistoriaClinica
          }/antecedentesAndrogenicos/${
            antecedentesAndrogenicos.fk_idAntecedentesAndrogenicos}`,
          antecedentesAndrogenicos,
        );
    },
  },
};
